export default {
  token: null,
  data: null,
  loading: false,
};
